import axiosInstance from './httpService';

const basePathForms = '/kalte-lust-forms/forms';

const contactFormService = {
  sendContactForm(contactFormData) {
    return axiosInstance.post(`${basePathForms}/contact`, contactFormData);
  }
};

export default contactFormService;
